export enum SoundStorageArea {
    Area1 = 'Area1',
    Area2 = 'Area2',
}